export default __webpack_public_path__ + "static/media/trend-down.0a130373.svg";